import { Button } from "@moneyforward/mfx_biz_react_components";
import { css } from "@emotion/react";
import Router from "next/router";

export const ConnectBoardLoginButton = () => {
  const onClick = () => {
    Router.push("/connect-biz/redirect-login");
  };

  return (
    <div css={buttonWrapper}>
      <Button type="button" onClick={onClick}>
        {/* ConnectBoardユーザーはログイン手段としてConnectBoard経由しか存在しない */}
        {/* したがって、「CONNECT-BIZでログイン」という表現はユーザーを惑わせてしまうと考えられる */}
        {/* そのため、単に「ログイン」という表現にする */}
        ログイン
      </Button>
    </div>
  );
};

const buttonWrapper = css({
  display: "flex",
  justifyContent: "center",
  marginBottom: "80px",
  marginTop: "60px",
});
